import OnlypayLogoCompleteNewIcon from './OnlypayLogoCompleteNewIcon'

export default OnlypayLogoCompleteNewIcon
